import { Route, Switch } from "react-router-dom";
import TermsAndConditionsPage from "../Pages/termsAndConditionPage";
import { BestWaterAppTermsAndConditionsPage } from "../Pages/bestWaterAppTermsAndConditionsPage";
import React, { useEffect, useState } from "react";
import ProAppTermsAndConditionsPage from "../Pages/proAppTermsAndConditionsPage";
import BestWaterAppTermsAndConditionsPageGerman from "../Pages/bestWaterAppTermsAndConditionsPageGerman";
import { getProfile, ProfileDto } from "../utils/accountAPI";

type AuthState =
  | { isAuth: true; profile?: ProfileDto; issue?: "Profile missing" }
  | { isAuth: false; state?: "loading" };

export default function TermsAndConditionsRoutes() {
  const [language, setLanguage] = useState<string>("");
  const [authState, setState] = React.useState<AuthState>({
    isAuth: false,
    state: "loading",
  });

  useEffect(() => {
    getProfile().then(
      (profile) => {
        if (profile === "Profile missing") {
          setState({ isAuth: true, issue: "Profile missing" });
          return;
        }
        setState({ isAuth: true, profile });
      },
      () => {
        setState({ isAuth: false });
      }
    );
  }, []);

  const prefLanguage = authState.isAuth
    ? authState.profile?.PreferredLanguage
    : null;

  useEffect(() => {
    setLanguage(getBrowserLanguage());
  }, []);

  return (
    <Switch>
      <Route
        exact
        path="/TermsAndConditions"
        component={TermsAndConditionsPage}
      />
      <Route
        path="/TermsAndConditions/BWTBestWaterApp"
        component={
          authState.isAuth && prefLanguage
            ? prefLanguage === "de"
              ? BestWaterAppTermsAndConditionsPageGerman
              : BestWaterAppTermsAndConditionsPage
            : language.includes("de")
            ? BestWaterAppTermsAndConditionsPageGerman
            : BestWaterAppTermsAndConditionsPage
        }
      />
      <Route
        path="/TermsAndConditions/BWTProApp"
        component={ProAppTermsAndConditionsPage}
      />
    </Switch>
  );
}

function getBrowserLanguage(): string {
  const lang =
    navigator.languages && navigator.languages.length > 0
      ? navigator.languages[0]
      : navigator.language || (navigator as any).userLanguage || "en";
  return lang;
}
